import React, { useEffect, useMemo, useState } from "react";
import { withRouter } from "../../../utils/router";
import queryString from "query-string";
import dayjs from "dayjs";

import { withRequest } from "../../../utils/request";
import { formatCurrency } from "../../../utils/helpers";
import { auth } from "../../../utils/auth";

function DetalleComisiones({ match, location, request }) {
    const [nomina, setNomina] = useState({});
    const [categorias, setCategorias] = useState([]);

    const { id, comision } = match.params;

    useEffect(() => {
        const getNomina = async () => {
            const search = location.search || "";
            const url = `nominas/${id}/comisiones/${comision}${search}`;
            const response = await request(url);

            if (response.success) {
                setNomina(response.data);
            }
        };

        const getCategorias = async () => {
            const search = location.search || "";
            const url = `grupos`;
            const response = await request(url);

            if (response.data) {
                setCategorias(response.data);
            }
        };

        getNomina();
        getCategorias();
    }, [id, comision, location.search, request]);

    const user = auth.getUser();
    const sucursal = user.sucursales.find((suc) => suc.id === user.sucursalActual) || {};
    const query = queryString.parse(location.search);

    const totales = useMemo(
        () =>
            nomina?.transacciones?.reduce(
                (acc, t) => {
                    acc.subtotal += t.subtotal;
                    acc.monto += t.monto;
                    acc.comision += t.comision;
                    return acc;
                },
                { subtotal: 0, monto: 0, comision: 0 }
            ),
        [nomina.transacciones]
    );

    const numeraciones = useMemo(
        () =>
            nomina?.transacciones?.reduce((acc, pago) => {
                if (typeof acc[pago.numeracion] === "undefined") {
                    acc[pago.numeracion] = [];
                }
                acc[pago.numeracion].push(pago);
                return acc;
            }, {}) || {},
        [nomina.transacciones]
    );
    return (
        <div>
            <style>{`@page {size: 11in  8.5in;} *{font-size: 14px}`}</style>
            <div className='row'>
                {nomina?.cerradaEn && (
                    <div className='fecha_cierre col-md-12'>
                        Nomina Cerrada:{" "}
                        {dayjs(nomina?.cerradaEn).format("DD/MM/YYYY")}
                    </div>
                )}
                <h3 className='col-md-12 text-center m-b-5'>
                    Detalle de {nomina?.nombre} {" "} - {nomina?.codigo} - {nomina?.empleado}
                    {query.contrato === "informal" ? "Informales" : ""}
                </h3>
                <div className='col-md-12 text-center'>
                    {sucursal.nombre} - {sucursal.direccion} •{" "}
                    {dayjs(nomina?.desde).format("DD/MM/YYYY")} -{" "}
                    {dayjs(nomina?.hasta).format("DD/MM/YYYY")}
                </div>
            </div>
            <div className='row text-right'>
                <div className='col text-left'>
                    {nomina?.settings?.tipo_comision === "Categorías" ? (
                        <>
                            <div>TRANSACCIONES: {nomina?.transacciones?.length}</div>
                            <div>
                                PORCENTAJES: GENERAL: {nomina.porcentaje}% - {nomina.settings?.categorias?.map((categoria) => `${categorias.find((c) => c.id == categoria.id)?.nombre}: ${categoria.porcentaje}%`).join(" - ")}
                            </div>
                            <div>
                                {nomina.settings.incluir_impuestos === 'true' ? 'Incluye Impuestos' : 'NO Incluye Impuestos'} | {nomina.settings.ventas === 'true' ? 'Comisión por Ventas' : 'Comisión por Cobros'} | {nomina.settings.dias_vencimiento ? `Excluyendo Vencidas (+${nomina.settings.dias_vencimiento} días)` : 'Incluye Vencidas' }
                            </div>
                        </>
                    ) : (
                        <>TRANSACCIONES: {nomina?.transacciones?.length} - PORCENTAJE COMISIÓN: {nomina?.porcentaje}%</>
                    )}
                </div>

                <div className='col text-right'>
                    <h3>TOTAL: {formatCurrency(nomina?.total)}</h3>
                </div>
            </div>
            <div className="mt-3">
                {Object.keys(numeraciones).map((numeracion) => {
                    const totalSubtotal = numeraciones[numeracion].reduce((acc, pago) => acc + pago.subtotal, 0);
                    const totalImpuestos = numeraciones[numeracion].reduce((acc, pago) => acc + (pago.monto - pago.subtotal), 0);
                    const totalGeneral = numeraciones[numeracion].reduce((acc, pago) => acc + pago.monto, 0);
                    const totalComision = numeraciones[numeracion].reduce((acc, pago) => acc + pago.comision, 0);
                    const totalNotasCredito = numeraciones[numeracion].reduce((acc, pago) => acc + parseFloat(pago.notas_credito), 0);

                    return (
                        <React.Fragment key={numeracion}>
                            <h3>
                                {numeracion} <span className='float-right'>{numeraciones[numeracion].length} Transacciones</span>
                            </h3>
                            <table className='table m-b-50'>
                                <thead>
                                    <tr>
                                        <th>NFC/Número</th>
                                        <th width="100px">Fecha</th>
                                        <th>Estado</th>
                                        <th className='text-right'>Subtotal</th>
                                        <th className='text-right'>Impuesto</th>
                                        <th className='text-right'>Total</th>
                                        <th className='text-right'>% N.C.</th>
                                        <th className='text-right'>Detalle</th>
                                        <th className='text-right'>Comisión</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {numeraciones[numeracion].map((transaccion, index) => (
                                        <tr key={index}>
                                            <td>
                                                <div>{transaccion.numero}</div>
                                                <small>{transaccion.codigo} - {transaccion.cliente}</small>
                                            </td>
                                            <td>
                                                {transaccion.fecha}
                                                <div><small>V: {transaccion.vencimiento}</small></div>
                                                {nomina.dias_vencimiento > 0 && (
                                                    <div>
                                                        <small>T: {dayjs(transaccion.tope).format("YYYY-MM-DD")}</small>
                                                    </div>
                                                )}
                                            </td>
                                            <td>
                                                <div style={{textDecorationLine: (transaccion.notas_credito > 0 && transaccion.comision === 0) || transaccion.vencida ? 'line-through' : 'none'}}>{transaccion.estado?.toUpperCase()} </div>
                                                {transaccion.vencida && (<div>VENCIDA</div>)}
                                                <small>{transaccion.fecha_pago ? dayjs(transaccion.fecha_pago).format("YYYY-MM-DD") : ''}</small>
                                            </td>
                                            <td className='text-right'>{formatCurrency(transaccion.subtotal)}</td>
                                            <td className='text-right'>{formatCurrency(transaccion.monto - transaccion.subtotal)}</td>
                                            <td className='text-right'>{formatCurrency(transaccion.monto)}</td>
                                            <td className='text-right'>{formatCurrency(transaccion.notas_credito)}</td>
                                            <td className='text-right'>
                                                <table className='table no-border' style={{tableLayout: 'fixed', maxWidth: '170px', float: 'right'}}>
                                                    <tbody>
                                                        {transaccion.detalles && Object.keys(transaccion.detalles).map(key => (
                                                            <tr key={key} className="no-border">
                                                                <td className="uppercase text-right">{key}</td>
                                                                <td className='text-right' style={{verticalAlign: 'bottom'}}>{formatCurrency(transaccion.detalles[key].comision)}</td>
                                                            </tr>
                                                        ))}
                                                    </tbody>
                                                </table>
                                            </td>
                                            <td className='text-right'>{formatCurrency(transaccion.comision)}</td>
                                        </tr>
                                    ))}
                                    <tr>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td className='text-right bold'>{formatCurrency(totalSubtotal)}</td>
                                        <td className='text-right bold'>{formatCurrency(totalImpuestos)}</td>
                                        <td className='text-right bold'>{formatCurrency(totalGeneral)}</td>
                                        <td className='text-right bold'>{formatCurrency(totalNotasCredito)}</td>
                                        <td></td>
                                        <td className='text-right bold'>{formatCurrency(totalComision)}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </React.Fragment>
                    );
                })}
            </div>

            <h3 className='text-center'>Totales</h3>
            <table className='table'>
                <thead>
                    <tr>
                        <th className='text-center'>Transacciones</th>
                        <th className='text-center'>Porcentaje Comisión</th>
                        <th className='text-center'>Importe</th>
                        <th className='text-center'>Impuesto</th>
                        <th className='text-center'>Ventas Total</th>
                        <th className='text-center'>Comisión Total</th>
                        {/* <th className='text-right'>nota</th> */}
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td className='text-center'>{nomina.transacciones?.length}</td>
                        <td className='text-center'>{nomina.porcentaje}</td>
                        <td className='text-center'>{formatCurrency(totales?.subtotal)}</td>
                        <td className='text-center'>{formatCurrency(totales?.monto - totales?.subtotal)}</td>
                        <td className='text-center'>{formatCurrency(totales?.monto)}</td>
                        <td className='text-center'>{formatCurrency(nomina.total)}</td>
                        {/* <td></td> */}
                    </tr>
                </tbody>
            </table>
        </div>
    );
}

export default withRouter(withRequest(DetalleComisiones));
